// src/utils/axiosInstance.js (adjust path based on your project structure)
// import axios from "axios";
// import API_BASE_URL from "./baseURL";

// const axiosInstance = axios.create({
//   baseURL: API_BASE_URL,
// });

// // Request interceptor to automatically attach JWT token
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

import axios from "axios";
import API_BASE_URL from "./baseURL";

// Create instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Required for sending cookies
});

// Attach token before request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auto-refresh on 401
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Prevent infinite loop
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        // Try refreshing the access token
        const res = await axios.post(
          `${API_BASE_URL}/Auth/refresh-token`,
          {},
          { withCredentials: true }
        );

        const newToken = res.data.token;
        // Save new token
        localStorage.setItem("token", newToken);

        // Retry original request with new token
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.log("Refresh token failed", refreshError);
        // Optionally clear storage and redirect to login
        localStorage.removeItem("token");
        window.location.href = "/Login";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
